import { theme } from "../../theme";

export default function Header({ title, back, right, goFeed }) {
  return (
    <header role="banner" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "16px 20px 12px", borderBottom: `1px solid ${theme.border}`, background: theme.surface, position: "sticky", top: 0, zIndex: 50 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 4, minWidth: 90 }}>
        <button
          onClick={back || goFeed}
          aria-label={back ? "Til baka" : "Heim"}
          style={{ background: "none", border: "none", cursor: "pointer", padding: "4px 6px", fontSize: 22, lineHeight: 1, borderRadius: 8, minWidth: 36, minHeight: 36, display: "flex", alignItems: "center", justifyContent: "center" }}
        >
          🚛
        </button>
        <button
          onClick={goFeed}
          aria-label="Fara heim"
          style={{ background: "none", border: "none", cursor: "pointer", padding: "4px 2px", fontSize: 18, fontWeight: 800, lineHeight: 1, WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", backgroundImage: `linear-gradient(135deg, ${theme.accent}, ${theme.green})` }}
        >
          Greiði
        </button>
      </div>
      <span style={{ fontSize: 16, fontWeight: 700 }}>{title || ""}</span>
      {right || <div style={{ width: 90 }} />}
    </header>
  );
}
